<template>
  <div>
    <nav-title :color="false" :title="'Problem Solving'" />

    <empty-module
      v-if="getCauseList.beforeActions.length == 0"
      :title="'There are no Problem Solving available for this problem'"
      :icon="'contact_support'"
    />

    <section v-else class="container">
      <h5 class="text-center p-3 m-0 text-darked">
        {{ problemName }}
      </h5>
      <b-card no-body class="border-0 w-100 time-help container">
        <b-tabs card>
          <b-tab title="BEFORE" :active="true" class="text-center">
            <div class="p-3">
              <h5>
                What's happening before?
              </h5>
              <p>
                Which one is most challenging?
              </p>
            </div>
            <causes-list :options="getCauseList.beforeActions" ref="causesBefore" />
            <b-button block variant="warning" @click="setAfter = true" class="text-uppercase my-3">
              Next
            </b-button>
          </b-tab>
          <b-tab title="AFTER" :active="setAfter" class="text-center">
            <h5 class="p-3">
              What's happening after?
            </h5>
            <causes-list :options="getCauseList.afterActions" ref="causesAfter" />
            <p class="mt-3">
              Click to review strategies to address
              <span class="text-lowercase">
                {{ problemName }}
              </span>
            </p>
            <b-button block variant="warning" @click="sendData" class="text-uppercase my-3">
              Go
            </b-button>
          </b-tab>
        </b-tabs>
      </b-card>
    </section>
  </div>
</template>
<script>
import navTitle from '@/components/general/navTitle.vue';
import causesList from '@/components/help/itemsList.vue';
import emptyModule from '@/components/general/emptyModule.vue';
import { mapGetters } from 'vuex';
import store from '@/store';

export default {
  components: {
    navTitle,
    causesList,
    emptyModule,
  },
  methods: {
    sendData() {
      this.$router.push({
        name: 'HelpSelectChange',
        query: {
          causesBefore: this.$refs.causesBefore.items,
          causesAfter: this.$refs.causesAfter.items,
          userProblemName: this.problemName,
          userProblemId: this.problemId,
        },
      });
    },
    getProblemName() {
      this.getProblemList.forEach((element) => {
        const elmt = this.$route.params.Mid;
        if (element.value == elmt) {
          this.problemId = elmt;
          this.problemName = element.text;
        }
      });
    },
    setDisabled() {
      let disabled = false;
      if (this.$refs.causesBefore.items != []) disabled = true;
      return disabled;
    },
  },
  computed: {
    ...mapGetters('help', ['getProblemList']),
    ...mapGetters('help', ['getCauseList']),
    getItems() {
      if (this.$refs.causesBefore) return this.$refs.causesBefore.items;
      else return 0;
    },
  },
  beforeRouteEnter(to, from, next) {
    let problemId = to.params.Mid;
    Promise.all([store.dispatch('help/FetchCauses', problemId)]).then(() => {
      next();
    });
  },
  mounted() {
    this.getProblemName();
  },
  data() {
    return {
      problemName: null,
      problemId: null,
      setAfter: false,
    };
  },
};
</script>
<style lang="scss">
.time-help .nav-tabs .nav-item {
  width: 50%;
  text-align: center;
}
.time-help .card-header {
  padding: 0;
  padding-bottom: 0.75rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.time-help .card-body {
  padding: 0;
}
</style>
